import React from 'react'
import { Modal, Backdrop } from '@mui/material'
import { Add } from '@mui/icons-material'
import metamaskIcon from '/assets/Icon/MetaMask.svg'
import crossmintIcon from '/assets/Icon/Crossmint.png'

interface ConnectWalletModalProps {
  open: boolean
  onClose: () => void
  onSelectMetaMask: () => void
  onSelectCrossmint: () => void
  connecting?: 'metamask' | 'crossmint' | null
  error?: string | null
}

const ConnectWalletModal = ({
  open,
  onClose,
  onSelectMetaMask,
  onSelectCrossmint,
  connecting = null,
  error = null
}: ConnectWalletModalProps) => {
  const isBusy = connecting !== null
  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
        sx: { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
      }}
      className="flex items-center justify-center"
    >
      <div className="relative w-[90%] max-w-[520px] rounded-lg bg-[#1a1a1a] outline-none">
        <div
          className="absolute right-3 top-3 flex size-8 cursor-pointer items-center justify-center"
          onClick={onClose}
        >
          <Add
            style={{
              transform: 'rotate(45deg)',
              color: '#ffffff',
              fontSize: '28px'
            }}
          />
        </div>

        <div className="p-6">
          <h2 className="mb-1 text-xl font-bold text-white">
            Connect a Wallet
          </h2>
          <p className="mb-5 text-sm text-[#a6a6a6]">All Wallets</p>

          <div className="flex flex-col gap-3">
            <button
              type="button"
              onClick={onSelectMetaMask}
              disabled={isBusy}
              className="flex w-full items-center gap-3 rounded-lg border border-[#333] p-4 transition-colors hover:border-[#555] hover:bg-[#222] disabled:cursor-not-allowed disabled:opacity-50"
            >
              <img
                src={metamaskIcon}
                alt="MetaMask"
                className="size-10 rounded-lg"
              />
              <div className="flex flex-col items-start">
                <span className="text-base font-semibold text-white">
                  {connecting === 'metamask' ? 'Connecting…' : 'MetaMask'}
                </span>
                <div className="mt-1 flex gap-2">
                  <span className="rounded-full bg-[#4ade8020] px-2 py-0.5 text-xs text-green0">
                    Extension
                  </span>
                  <span className="rounded-full bg-[#4ade8020] px-2 py-0.5 text-xs text-green0">
                    Mobile
                  </span>
                </div>
              </div>
            </button>

            <button
              type="button"
              onClick={onSelectCrossmint}
              disabled={isBusy}
              className="flex w-full items-center gap-3 rounded-lg border border-[#333] p-4 transition-colors hover:border-[#555] hover:bg-[#222] disabled:cursor-not-allowed disabled:opacity-50"
            >
              <img
                src={crossmintIcon}
                alt="Crossmint"
                className="size-10 rounded-lg"
              />
              <div className="flex flex-col items-start">
                <span className="text-base font-semibold text-white">
                  {connecting === 'crossmint'
                    ? 'Creating wallet…'
                    : 'Crossmint'}
                </span>
                <div className="mt-1 flex gap-2">
                  <span className="rounded-full bg-[#4ade8020] px-2 py-0.5 text-xs text-green0">
                    Seedless Wallet
                  </span>
                  <span className="rounded-full bg-[#4ade8020] px-2 py-0.5 text-xs text-green0">
                    Card Payment
                  </span>
                </div>
              </div>
            </button>
          </div>

          {error && (
            <p className="mt-4 break-words text-sm text-red-400">{error}</p>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default ConnectWalletModal
